export enum TabStepEnum {
  SHOP_INFO = 'SHOP_INFO',
  CATEGORY = 'CATEGORY',
  PRODUCT = 'PRODUCT',
  SHOP_BUILDER = 'SHOP_BUILDER',
  OLD_USER = 'OLD_USER',
}
